window.$ = window.jQuery = global.$ = global.jQuery = require('jquery');
require('bootstrap');
